export interface Product {
  id: string
  name: string
  type: 'COD CP' | 'FIFA Coins' | 'TikTok Account' | 'Game Account'
  description: string
  price: number
  status: 'approved' | 'pending' | 'rejected'
  views: number
  sales: number
  isVerified: boolean
  image: string
  sellerName: string
  sellerRating: number
}

export interface Order {
  id: string
  productName: string
  productId: string
  buyerName: string
  amount: number
  status: 'pending' | 'processing' | 'completed'
  date: string
}

export interface Transaction {
  id: string
  type: 'sale' | 'withdrawal'
  amount: number
  description: string
  date: string
}

export interface BankDetails {
  bankName: string
  accountNumber: string
  accountName: string
  isLinked: boolean
}

// Gaming placeholder images
export const productImages: Record<string, string> = {
  'COD CP':
    'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop&q=80',
  'FIFA Coins':
    'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=400&h=400&fit=crop&q=80',
  'TikTok Account':
    'https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&h=400&fit=crop&q=80',
  'Game Account':
    'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=400&h=400&fit=crop&q=80',
  default:
    'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400&h=400&fit=crop&q=80',
}

export const products: Product[] = [
  {
    id: '1',
    name: '10,000 COD CP Points',
    type: 'COD CP',
    description:
      'Call of Duty Mobile CP Points. Instant delivery within 5 minutes. Valid for all regions.',
    price: 8500,
    status: 'approved',
    views: 234,
    sales: 45,
    isVerified: true,
    image:
      'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '2',
    name: 'FIFA 24 - 12,000 Coins',
    type: 'FIFA Coins',
    description:
      'FIFA 24 Ultimate Team coins. Safe transfer method. No ban risk.',
    price: 15000,
    status: 'approved',
    views: 189,
    sales: 32,
    isVerified: true,
    image:
      'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '3',
    name: 'TikTok Account - 50K Followers',
    type: 'TikTok Account',
    description:
      'Verified TikTok account with 50,000 real followers. Good engagement rate.',
    price: 45000,
    status: 'pending',
    views: 0,
    sales: 0,
    isVerified: false,
    image:
      'https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '4',
    name: '5,000 COD CP Points',
    type: 'COD CP',
    description:
      'Call of Duty Mobile CP Points. Fast delivery. Trusted seller.',
    price: 4200,
    status: 'approved',
    views: 312,
    sales: 67,
    isVerified: true,
    image:
      'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '5',
    name: 'PUBG Mobile - 3,000 UC',
    type: 'Game Account',
    description: 'PUBG Mobile Unknown Cash. Direct top-up to your account.',
    price: 12000,
    status: 'rejected',
    views: 45,
    sales: 0,
    isVerified: false,
    image:
      'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '6',
    name: 'FIFA 24 - 25,000 Coins',
    type: 'FIFA Coins',
    description:
      'Large FIFA coins bundle. Best value for money. Safe and fast.',
    price: 28000,
    status: 'approved',
    views: 156,
    sales: 28,
    isVerified: true,
    image:
      'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '7',
    name: 'TikTok Account - 100K Followers',
    type: 'TikTok Account',
    description: 'Premium TikTok account with 100K followers. High engagement.',
    price: 85000,
    status: 'pending',
    views: 0,
    sales: 0,
    isVerified: false,
    image:
      'https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
  {
    id: '8',
    name: '20,000 COD CP Points',
    type: 'COD CP',
    description: 'Bulk COD CP points. Best deal for serious gamers.',
    price: 16500,
    status: 'approved',
    views: 278,
    sales: 41,
    isVerified: true,
    image:
      'https://images.unsplash.com/photo-1542751371-adc38448a05e?w=400&h=400&fit=crop&q=80',
    sellerName: 'Adebayo Johnson',
    sellerRating: 4.5,
  },
]

export const orders: Order[] = [
  {
    id: 'ORD001',
    productName: '10,000 COD CP Points',
    productId: '1',
    buyerName: 'Chukwudi Okafor',
    amount: 8500,
    status: 'pending',
    date: '2026-04-16T10:30:00',
  },
  {
    id: 'ORD002',
    productName: 'FIFA 24 - 12,000 Coins',
    productId: '2',
    buyerName: 'Amina Bello',
    amount: 15000,
    status: 'processing',
    date: '2026-04-16T09:15:00',
  },
  {
    id: 'ORD003',
    productName: '5,000 COD CP Points',
    productId: '4',
    buyerName: 'Tunde Adeyemi',
    amount: 4200,
    status: 'completed',
    date: '2026-04-15T16:45:00',
  },
  {
    id: 'ORD004',
    productName: 'FIFA 24 - 25,000 Coins',
    productId: '6',
    buyerName: 'Ngozi Eze',
    amount: 28000,
    status: 'completed',
    date: '2026-04-15T14:20:00',
  },
  {
    id: 'ORD005',
    productName: '10,000 COD CP Points',
    productId: '1',
    buyerName: 'Ibrahim Musa',
    amount: 8500,
    status: 'processing',
    date: '2026-04-16T08:00:00',
  },
  {
    id: 'ORD006',
    productName: '20,000 COD CP Points',
    productId: '8',
    buyerName: 'Fatima Yusuf',
    amount: 16500,
    status: 'completed',
    date: '2026-04-14T11:30:00',
  },
  {
    id: 'ORD007',
    productName: 'FIFA 24 - 12,000 Coins',
    productId: '2',
    buyerName: 'Emeka Okonkwo',
    amount: 15000,
    status: 'completed',
    date: '2026-04-14T09:00:00',
  },
  {
    id: 'ORD008',
    productName: '5,000 COD CP Points',
    productId: '4',
    buyerName: 'Aisha Mohammed',
    amount: 4200,
    status: 'pending',
    date: '2026-04-16T11:45:00',
  },
]

export const transactions: Transaction[] = [
  {
    id: 'TXN001',
    type: 'sale',
    amount: 8500,
    description: 'Sale: 10,000 COD CP Points',
    date: '2026-04-16T10:30:00',
  },
  {
    id: 'TXN002',
    type: 'sale',
    amount: 15000,
    description: 'Sale: FIFA 24 - 12,000 Coins',
    date: '2026-04-16T09:15:00',
  },
  {
    id: 'TXN003',
    type: 'withdrawal',
    amount: -25000,
    description: 'Withdrawal to GTBank',
    date: '2026-04-15T18:00:00',
  },
  {
    id: 'TXN004',
    type: 'sale',
    amount: 4200,
    description: 'Sale: 5,000 COD CP Points',
    date: '2026-04-15T16:45:00',
  },
  {
    id: 'TXN005',
    type: 'sale',
    amount: 28000,
    description: 'Sale: FIFA 24 - 25,000 Coins',
    date: '2026-04-15T14:20:00',
  },
  {
    id: 'TXN006',
    type: 'withdrawal',
    amount: -50000,
    description: 'Withdrawal to Access Bank',
    date: '2026-04-14T20:00:00',
  },
  {
    id: 'TXN007',
    type: 'sale',
    amount: 16500,
    description: 'Sale: 20,000 COD CP Points',
    date: '2026-04-14T11:30:00',
  },
  {
    id: 'TXN008',
    type: 'sale',
    amount: 15000,
    description: 'Sale: FIFA 24 - 12,000 Coins',
    date: '2026-04-14T09:00:00',
  },
  {
    id: 'TXN009',
    type: 'sale',
    amount: 8500,
    description: 'Sale: 10,000 COD CP Points',
    date: '2026-04-13T15:30:00',
  },
  {
    id: 'TXN010',
    type: 'sale',
    amount: 4200,
    description: 'Sale: 5,000 COD CP Points',
    date: '2026-04-13T12:15:00',
  },
]

export const walletBalance = {
  available: 127300,
  pending: 23500,
}

export const profileData = {
  name: 'Adebayo Johnson',
  email: 'adebayo@kdx.com',
  phone: '+234 803 456 7890',
  isVerified: true,
  rating: 4.5,
  totalSales: 213,
  joinDate: '2025-08-15',
  bankDetails: {
    bankName: 'GTBank',
    accountNumber: '0123456789',
    accountName: 'Adebayo Johnson',
    isLinked: true,
  } as BankDetails,
}
